export default {
  state: {
    getShopNameCheckout: [],
    putSettingsCheckout: []
  },

  getters: {
    getShopNameCheckout: state => state.getShopNameCheckout,
    putSettingsCheckout: state => state.putSettingsCheckout
  },

  mutations: {
    setShopNameCheckout(state, val) {
      state.getShopNameCheckout = {
        shopify_shop: val.shopify_shop,
        token_id: val.token_id,
        is_activated: val.is_activated,
        configuration: val.configuration
      }
    }
  }
}